import APICall from "../utils/APICall";

export const ONLINE_ACCOUNT_APP_NAME = "OnlineAccount";
export const PREMIUM_MOBILE_APP_NAME = "PremiumMobile";

export default class QuickOnlineAccountServices {
  static listAccounts = async (page, pageLimit, search, from, to, accountOpeningMedium) => {
    var url = `/api/QuickOnlineAccountOpening/admin/list/quick-online-account?page=${page}&pageLimit=${pageLimit}`;
    if (search) url = `${url}&search=${search}`;
    if (from) url = `${url}&from=${from}`;
    if (to) url = `${url}&to=${to}`;
    if (accountOpeningMedium) url = `${url}&accountOpeningMedium=${accountOpeningMedium}`;
    return await APICall(url, "GET");
  };

  static viewAccount = async (id) => {
    return await APICall(
      `/api/QuickOnlineAccountOpening/admin/view/quick-online-account?id=${id}`,
      "GET"
    );
  };

  static exportAccounts = async (search, from, to) => {
    var url = `/api/QuickOnlineAccountOpening/admin/export/quick-online-account`;
    var params = [];
    if (search) params.push(`search=${search}`);
    if (from) params.push(`from=${from}`);
    if (to) params.push(`to=${to}`);
    if (params.length) url = `${url}?${params.join("&")}`;
    return await APICall(url, "GET");
  };

  static listLivenessImages = async (appName, tenantId, startDate, endDate, page, pageLimit, search, selfImageUrl, customerId) => {
    var url = `/api/QuickOnlineAccountOpening/admin/list/liveness-images?appName=${appName}&tenantId=${tenantId}&page=${page}&pageLimit=${pageLimit}`;
    if (startDate) url = `${url}&startDate=${startDate}`;
    if (endDate) url = `${url}&endDate=${endDate}`;
    if (search) url = `${url}&search=${encodeURIComponent(search)}`;
    if (selfImageUrl) url = `${url}&selfImageUrl=${encodeURIComponent(selfImageUrl)}`;
    if (customerId) url = `${url}&customerId=${encodeURIComponent(customerId)}`;
    return await APICall(url, "GET");
  };

  static removePnd = async (accountNumber) => {
    return await APICall(
      `/api/QuickOnlineAccountOpening/admin/remove-pnd/quick-online-account?accountNumber=${accountNumber}`,
      "PATCH"
    );
  };

  static listReferralCodes = async (page, pageLimit, search, isActive) => {
    let url = `/api/QuickOnlineAccountOpening/admin/get-referral-codes?page=${page}&pageLimit=${pageLimit}`;
    if (search) url = `${url}&search=${encodeURIComponent(search)}`;
    if (isActive !== undefined && isActive !== null && isActive !== "") {
      url = `${url}&isActive=${isActive}`;
    }
    return await APICall(url, "GET");
  };

  static createReferralCode = async (payload) => {
    return await APICall(
      "/api/QuickOnlineAccountOpening/admin/create-referral-codes",
      "POST",
      payload
    );
  };

  static updateReferralCode = async (id, payload) => {
    return await APICall(
      `/api/QuickOnlineAccountOpening/admin/update-referral-codes/${id}`,
      "PUT",
      payload
    );
  };

  static deleteReferralCode = async (id) => {
    return await APICall(
      `/api/QuickOnlineAccountOpening/admin/delete-referral-codes/${id}`,
      "DELETE"
    );
  };

  static exportReferralCodes = async (search, isActive, from, to) => {
    let url = `/api/QuickOnlineAccountOpening/admin/export-referral-codes`;
    const params = [];
    if (search) params.push(`search=${encodeURIComponent(search)}`);
    if (isActive !== undefined && isActive !== null && isActive !== "") {
      params.push(`isActive=${isActive}`);
    }
    if (from) params.push(`from=${encodeURIComponent(from)}`);
    if (to) params.push(`to=${encodeURIComponent(to)}`);
    if (params.length > 0) url = `${url}?${params.join("&")}`;
    return await APICall(url, "GET");
  };
}
